import { Injectable, NgZone } from '@angular/core';
import { User } from "./user";
import { auth, messaging } from 'firebase/app';
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestore, AngularFirestoreDocument, DocumentData, QuerySnapshot } from '@angular/fire/firestore';
import { Router } from "@angular/router";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { profile } from 'console';
// import { SenseService } from './sense.service';
// import { data } from 'jquery';
declare var M: any;

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  orders;shipments;
  user; userProfile;
  notified = false;
  userData: any; // Save logged in user data
  constructor(
    // public senseService: SenseService,
    public afs: AngularFirestore,   // Inject Firestore service
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    public router: Router,
    public ngZone: NgZone // NgZone service to remove outside scope warning
  ) {
    /* Saving user data in localstorage when 
    logged in and setting up null when logged out */
    this.afAuth.authState.subscribe(user => {
      if (user) {
        this.userData = user;
        localStorage.setItem('user', JSON.stringify(this.userData));
        JSON.parse(localStorage.getItem('user'));
        var that = this;
        // this.senseService.getProductsReady();
        // setInterval(function () {
        //   that.refreshUserProfile(user);
        // }, 180000)//? measure number of reads
        that.refreshUserProfile(user);


      } else {
        localStorage.setItem('user', null);
        localStorage.setItem("userProfile", null)
        JSON.parse(localStorage.getItem('user'));
      }
    })
  }

  refreshUserProfile(user) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
    userRef.get().toPromise().then((doc) => {
      if (doc.exists) {
        // console.log(doc.data())
        this.userProfile = doc.data();
        localStorage.setItem("userProfile", JSON.stringify(doc.data()))
        // console.log(this.userProfile.approver, this.userProfile.storage)
        // 
        if (this.userProfile.unreadMessages.length && !this.notified) {
          this.notified = true;
          M.toast({ html: 'You have ' + this.userProfile.unreadMessages.length + ' unread messages!' });
        }
        if(this.userProfile.approver) this.getPendingOrders();
        if(this.userProfile.storage) this.getPendingShipments() ;

      }
    }).catch(function (error) {
      //console.log("Error getting document:", error);
    });
  }
  
  getPendingOrders() {
    // console.log("calling server for ledger");
    // 
    this.afs.collection("generalSale", ref => ref.where('approved', '==', false)).get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        if (localStorage.getItem('newOrder')) {
          // console.log(querySnapshot.size > parseInt(localStorage.getItem('newOrder')));
          // ODO fix old notification bug
          querySnapshot.size > parseInt(localStorage.getItem('newOrder')) && querySnapshot.size && this.isLoggedIn ? M.toast({ html: 'There is  ' + querySnapshot.size +' pending orders!',displayLength:60000 }) : null;
          querySnapshot.size > parseInt(localStorage.getItem('newOrder')) ? localStorage.setItem('newOrder', querySnapshot.size.toString()) : null;
        } {
          // 
          querySnapshot.size == parseInt(localStorage.getItem('newOrder')) ? null : querySnapshot.size != 0 && this.isLoggedIn ?M.toast({ html: 'There is  ' + querySnapshot.size +' pending orders!', displayLength: 6000 }):null ;
          querySnapshot.size == parseInt(localStorage.getItem('newOrder')) ? null : localStorage.setItem('newOrder', querySnapshot.size.toString()) ;
        }
      });

  }
  getPendingShipments() {
    // console.log("calling server for ledger");
    // 
    // console.log('refresh')
    // 

    this.afs.collection("generalSale", ref => ref.where('shipped', '==', false).where('approved', '==', true)).get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        // console.log(querySnapshot.size);
        // 
        if (localStorage.getItem('newShipment')) {
          querySnapshot.size > parseInt(localStorage.getItem('newShipment')) && querySnapshot.size != 0 && this.isLoggedIn ? M.toast({ html: 'There is ' + querySnapshot.size +' pending Shipments!',displayLength:60000 }) : null;
          querySnapshot.size > parseInt(localStorage.getItem('newShipment')) ? localStorage.setItem('newShipment', querySnapshot.size.toString()) : null
        } else {
          querySnapshot.size == parseInt(localStorage.getItem('newShipment')) ? null : querySnapshot.size != 0 && this.isLoggedIn ?M.toast({ html: 'There is ' + querySnapshot.size +' pending Shipments!', displayLength: 6000 }):null;
          querySnapshot.size == parseInt(localStorage.getItem('newShipment')) ? null:localStorage.setItem('newShipment', querySnapshot.size.toString())
            }

      });


  }
  startChat(profile1: User, profile2: User) {
    var threadId = this.getMessageThreadID(profile1.uid, profile2.uid);
    profile1.messaging ? profile1.messaging.includes(threadId) ? null : profile1.messaging.push(threadId) : profile1.messaging = [threadId];
    profile2.messaging ? profile2.messaging.includes(threadId) ? null : profile2.messaging.push(threadId) : profile2.messaging = [threadId];
    profile1.messagingId ? profile1.messagingId.includes(profile2.uid) ? null : profile1.messagingId.push(profile2.uid) : profile1.messagingId = [profile2.uid];
    profile2.messagingId ? profile2.messagingId.includes(profile1.uid) ? null : profile2.messagingId.push(profile1.uid) : profile2.messagingId = [profile1.uid];

    this.updateMessages(profile1);
    this.updateMessages(profile2);
    return threadId;
  }
  getMessageThreadID(id1, id2) {
    var hash1 = parseInt(id1, 36);
    var hash2 = parseInt(id2, 36);
    var id = hash1 + hash2;
    return id.toString(36)

    // return this.bin2hex(this.addIds(this.convert(id1), this.convert(id2)))
  }
  hex2bin(hex) {
    return (parseInt(hex, 16).toString(2));

  }
  bin2hex(bin) {
    return (parseInt(bin, 2).toString(16));

  }
  convert(s) {
    var result = "";
    var input = s.forEach(str => {
      result += this.hex2bin(str)
    })
    return result;
  }
  addIds(id1, id2) {
    return parseInt(id1, 2) && parseInt(id2, 2);
  }
  // Sign in with email/password
  SignIn(email, password) {
    //console.log(email);
    // 
    return this.afAuth.signInWithEmailAndPassword(email, password)
      .then((result) => {
        //console.log(result);
        localStorage.setItem("user", JSON.stringify(result.user))
        const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${result.user.uid}`);
        userRef.get().toPromise().then((doc) => {
          if (doc.exists) {
            //console.log(doc.data)
            this.userProfile = doc.data();
            localStorage.setItem("userProfile", JSON.stringify(doc.data()))
            this.ngZone.run(() => {
              this.router.navigate(['dashboard']);
              M.toast({ html: 'Welcome Back ' + doc.data()['displayName'] + '!' })
              // if (doc.data()['unreadMessages'].length) M.toast({ html: 'You have ' + doc.data()['unreadMessages'].length +' unread messages!' });
              // var that = this;
              // that.refreshUserProfile(doc.data());
              // setInterval(function () {
              //   that.refreshUserProfile(doc.data());
              // }, 600000)
            });

            // console.log("Document data:", doc.data());
          } else {
            // doc.data() will be undefined in this case
            //console.log("No such document!");
          }
        }).catch(function (error) {
          //console.log("Error getting document:", error);
        });


        //this.SetUserData(result.user);
      }).catch((error) => {
        //console.log(email);
        M.toast({ html: error.message })
      })
  }

  // Sign up with email/password
  SignUp(email, password, data) {
    console.log(data);
    // M.toast({ html: 'Done!' })

    return this.afAuth.createUserWithEmailAndPassword(email, password)
      .then((result) => {
        /* Call the SendVerificaitonMail() function when new user sign 
        up and returns promise */
        this.SendVerificationMail();
        this.SetUserData(result.user, data);
      }).catch((error) => {
        M.toast({ html: error.message })
      })
  }
  SetUserData(user, data) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
    const userData: User = {
      uid: user.uid,
      email: user.email,
      displayName: data.name,
      number: data.phone,
      // photoURL: user.photoURL,
      emailVerified: user.emailVerified,
      admin: data.admin,
      storage: data.storage,
      sales: data.sales,
      approver: data.approver,
      messaging: [],
      messagingId: [],
      unreadMessages: [],

    }
    userRef.set(userData, {
      merge: true
    })
    this.afAuth.authState.subscribe(user => {
      if (user) {
        M.toast({ html: 'User profile created successfully!' })
        // this.userData = user;
        // localStorage.setItem('user', JSON.stringify(this.userData));
        // JSON.parse(localStorage.getItem('user'));
        // const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
        // userRef.get().toPromise().then((doc) => {
        //   if (doc.exists) {
        //     this.userProfile = doc.data;
        //     localStorage.setItem("userProfile", JSON.stringify(doc.data()))
        //   }
        // }).catch(function (error) {
        //   //console.log("Error getting document:", error);
        // });
      } else {

        // localStorage.setItem('user', null);
        // localStorage.setItem("userProfile", null)
        // JSON.parse(localStorage.getItem('user'));
      }
    })
  }
  // Send email verfificaiton when new user sign up
  async SendVerificationMail() {
    return (await this.afAuth.currentUser).sendEmailVerification()
      .then(() => {
        // this.router.navigate(['verify-email-address']);
        this.SignOut();
      })
  }

  // Reset Forggot password
  ForgotPassword(passwordResetEmail) {
    return this.afAuth.sendPasswordResetEmail(passwordResetEmail)
      .then(() => {
        M.toast({ html: 'Password reset email sent, check your inbox!' })

        // window.alert('.');
      }).catch((error) => {
        M.toast({ html: error })
      })
  }
  // Returns true when user is looged in and email is verified
  get isLoggedIn(): boolean {
    const user = JSON.parse(localStorage.getItem('user'));
    //console.log(user); //|| user.emailVerified !== false
    return (user !== null) ? true : false;
  }

  get getUser() {
    if (this.isLoggedIn) {
      this.user = JSON.parse(localStorage.getItem('user'));
      //console.log(this.user);
      return this.user
    } else {
      return { displayName: "", emailVerified: "" }
    }
  }
  get getUserProfile() {
    if (this.isLoggedIn) {
      this.userProfile = JSON.parse(localStorage.getItem('userProfile'));
      // console.log(this.userProfile)
      return this.userProfile
    } else {
      return { displayName: "", emailVerified: "" }
    }
  }

  get getShipments() {
    if (this.isLoggedIn) {
      this.shipments = parseInt(localStorage.getItem('newShipment'));
      // console.log(this.userProfile)
      if (this.shipments) return this.shipments
      else return 0;
    } else {
      return 0
    }
  }
  get getOrders() {
    if (this.isLoggedIn) {
      this.orders = parseInt(localStorage.getItem('newOrder'));
      // console.log(this.userProfile)
      if (this.orders) return this.orders
      else return 0;
    } else {
      return 0
    }
  }
  // Sign in with Google
  // GoogleAuth() {
  //   return this.AuthLogin(new auth.GoogleAuthProvider());
  // }

  // // Auth logic to run auth providers
  // AuthLogin(provider) {
  //   return this.afAuth.signInWithPopup(provider)
  //     .then((result) => {
  //       this.ngZone.run(() => {
  //         this.router.navigate(['dashboard']);
  //       })
  //       this.SetUserData(result.user);
  //     }).catch((error) => {
  //     M.toast({ html: error})
  //     })
  // }

  /* Setting up user data when sign in with username/password, 
  sign up with username/password and sign in with social auth  
  provider in Firestore database using AngularFirestore + AngularFirestoreDocument service */

  // handleResetPassword() {

  //   // Save the new password.   
  //   this.afAuth.getAuth().confirmPasswordReset(
  //     this.actionCode,
  //     this.newPassword
  //   ).then(resp => {
  //     // Password reset has been confirmed and new password updated.    
  //     alert('New password has been saved');
  //     // this.router.navigate(['/auth/login']);
  //   }).catch(e => {
  //     // Error occurred during confirmation. The code might have
  //     // expired or the password is too weak. alert(e); 
  //   });
  // }
  UpdateUserData(user, data) {
    // console.log(data, user);

    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
    const userData = {
      uid: user.uid,
      email: user.email,
      displayName: data.displayName,
      number: data.phone,
      // photoURL: user.photoURL,
      emailVerified: false,
      admin: data.admin,
      storage: data.storage,
      sales: data.sales,
      approver: data.approver,

    }
    // 
    userRef.update(userData).then(() => {
      M.toast({ html: 'User Data Updated!' })

    }).catch((error) => {
      M.toast({ html: error })
    })

  }
  UpdatePrivilegeByID(id, data) {
    // console.log(data, user);

    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${id}`);
    const userData = {
      admin: data.admin,
      storage: data.storage,
      sales: data.sales,
      approver: data.approver,
    }
    // 
    userRef.update(userData).then(any => {
      M.toast({ html: 'Privileges updated!' })

    }).catch ((error) => {
      M.toast({ html: error })
    })


  }
  updateMessages(p1: User) {
    // console.log(data, user);

    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${p1.uid}`);
    const userData = {
      messaging: p1.messaging,
      messagingId: p1.messagingId,
    }
    // 
    userRef.update(userData).then(() => {
      // M.toast({ html: 'Message thread created!' })
    }).catch((error) => {
      M.toast({ html: error })
    })


  }
  resetPassword(email: string) {

    this.afAuth.sendPasswordResetEmail(email, { url: "http://emei-co.firebase.com/" }).then(any => {
      M.toast({ html: 'Password reset email sent!' })

    }).catch((error) => {
      M.toast({ html: error })
    });
  }
  changeInfo(profile, number, name) {
    number ? profile.number = number : null;
    name ? profile.displayName = name : null;
    this.UpdateUserData(profile, profile);
  }
  // Sign out 
  SignOut() {
    return this.afAuth.signOut().then(() => {
      localStorage.clear()
      this.router.navigate(['sign-in']);
      M.toast({ html: 'Bye!' })

    })
  }

}